import en from './locale/en';
import pt from './locale/pt';
import pt_BR from './locale/pt_BR';

export default { en, pt, pt_BR };
